const MINUTE = 60 * 1000;

function getUpcomingAnnouncements(allAnnouncements, timeFrame = 15 * MINUTE) {
  const now = new Date().getTime();
  return allAnnouncements.filter(announcement => {
    const start = new Date(announcement.start).getTime();
    const end = new Date(announcement.end).getTime();
    return start - now <= timeFrame && end > now;
  });
}

export default getUpcomingAnnouncements;
